
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DocumentSummaryHistory } from "../../../domain/document";
import { DocumentViewerMenuButtons, IDocumentViewerMenuConfiguration } from "../viewers/contents";
import DocumentViewBaseMixin from "./DocumentViewBaseMixin.vue";
import RestrictedDocumentHandleableMixin from "./RestrictedDocumentHandleableMixin.vue";
import Enumerable from "linq";

@Component
export default class DocumentViewMixin extends Mixins(DocumentViewBaseMixin, RestrictedDocumentHandleableMixin) {
  @Prop()
  archiveId: number;

  data(): any {
    return {
      visibleButtons: Enumerable.from([
          DocumentViewerMenuButtons.print,
          DocumentViewerMenuButtons.printToSelectedPrinter,
          DocumentViewerMenuButtons.editNewQuotedDocument,
          DocumentViewerMenuButtons.editNote,
        ])
        .where(e => !!e)
        .toArray(),
      isReadableDocument: false,
      viewerMenuConfiguration: null as IDocumentViewerMenuConfiguration,
    };
  }
  isReadableDocument: boolean;
  viewerMenuConfiguration: IDocumentViewerMenuConfiguration;

  get isLoading(): boolean {
    return (!this.isLoaded && !!this.documentId)
      || (this.isLoaded && this.isVirtual && !this.isDeveloperMode);
  }

  get selectedArchiveId(): number {
    return (this.document instanceof DocumentSummaryHistory)
      ? this.document.archiveId
      : null;
  }

  get selectedHistory(): DocumentSummaryHistory {
    return ((this.document instanceof DocumentSummaryHistory) && !this.document.isLatest)
      ? this.document
      : null;
  }

  get isHistorySelected(): boolean {
    return !!this.selectedHistory;
  }

  get isDocumentNoteWritable(): boolean {
    // 編集不可・削除された状態であっても文書メモは編集可能とする
    return this.isLoaded;
  }

  get isDocumentQuotable(): boolean {
    return (this.document instanceof DocumentSummaryHistory) && this.document.isQuotable;
  }

  get alternativeFormatOriginalId(): number {
    return (this.document instanceof DocumentSummaryHistory) && this.document.alternativeFormatOriginalId;
  }

  private setViewerMenuConfiguration(): void {
    this.viewerMenuConfiguration = {
      buttons: {
        print: {
          name: DocumentViewerMenuButtons.print.name,
        },
        printToSelectedPrinter: {
          name: DocumentViewerMenuButtons.printToSelectedPrinter.name,
        },
        editNote: {
          name: this.$wording.document.note,
          description: "表示中の文書の" + this.$wording.document.note + "を編集します。",
        },
      }
    };
  }

  mounted() {
    this.setViewerMenuConfiguration();
    this.isReadConfirmedDocument(this.patientNo, this.documentId, "中止して画面を閉じる")
    .then(isReadable => {
      this.isReadableDocument = isReadable;
      if (!isReadable) {
        this.$closeWindow();
      }
    })
    .catch(e => {
      this.$error("エラー", "閲覧制限の判定処理でエラーが発生しました。", e);
    });
  }
}
